import { Route } from 'react-router-dom';
import React from 'react';
import { QueryRenderer } from 'react-relay';
import modernEnvironment from '../lib/RelayUtils';

const Query = (query, component, variables) => ({ match }) => (
	<QueryRenderer
		environment={modernEnvironment}
		query={query}
		variables={variables ? variables(match.params) : { ...match.params }}
		render={({ error, props }) => {
			if (error) {
				return <div>{error.message}</div>;
			}

			if (props) {
				const Comp = component;
				return <Comp {...props} />;
			}

			return <div>Loading...</div>;
		}}
	/>
);

export const WrappedRoute = ({ path, component, query, variables }) => <Route path={path} component={Query(query, component, variables)} />;



// WEBPACK FOOTER //
// src/util/wraped-route.jsx